module.exports = __webpack_public_path__ + "static/media/ccd3.1e84fa4c.jpeg";